<template>
  <div class="bg-light-gray overflow-x-hidden" style="min-height: 100vh">
    <Navbar :initialValue="query" :count="items.length" @search="handleSearch($event)"/>

    <div class="container px-0 py-md-8 bottom-nav-spacing" style="max-width: 1000px;">
      <v-row>
        <v-col cols="12" md="12">
          <v-row dense>
            <v-col v-for="(item, i) in items" :key="i" class="px-md-2 pb-0" cols="12" sm="4">
              <ItemCardMerchant
                v-if="item.source === 'instagram'"
                :item="item" @select="handleSelect(item)" @plans="current = item; views.plans = true;"
              />
              <ItemCardOthers
                v-else
                :item="item" @select="handleSelect(item)" @plans="current = item; views.plans = true;"
              />
            </v-col>
          </v-row>
          <v-row v-if="loading" dense>
            <v-col v-for="i in 4" :key="i" class="px-2 pb-0 mb-3" cols="12" sm="4">
              <ItemCardLoading/>
            </v-col>
          </v-row>

          <div v-if="!items.length && !loading">
            <div class="text-center py-10 py-md-16 d-flex flex-column align-center">
              <br><br><br><br>
              <img src="@/assets/images/shopping-app.svg/" alt="" style="width: 250px"/>
              <p class="mt-10" style="font-size: 1.5rem">No results</p>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>

    <BottomNav/>

    <v-dialog
      v-if="$vuetify.breakpoint.smAndDown" v-model="views.details" fullscreen hide-overlay
      transition="dialog-bottom-transition"
    >
      <ProductDetailsOther
        v-if="current" :item="current" @close="views.details = false; current = null;"
        @plans="views.details = false; views.plans = true"
      />
    </v-dialog>
    <v-navigation-drawer v-else v-model="views.details" fixed right temporary width="550">
      <ProductDetailsOther
        v-if="current" :item="current" @close="views.details = false; current = null;"
        @plans="views.details = false; views.plans = true"
      />
    </v-navigation-drawer>

    <v-dialog
      v-if="$vuetify.breakpoint.smAndDown" v-model="views.plans" fullscreen hide-overlay
      transition="dialog-bottom-transition"
    >
      <ProductPlans v-if="current" :item="current" @close="views.plans = false"/>
    </v-dialog>
    <v-navigation-drawer v-else v-model="views.plans" fixed right temporary width="550">
      <ProductPlans v-if="current" :item="current" @close="views.plans = false"/>
    </v-navigation-drawer>

    <v-btn
      v-if="$vuetify.breakpoint.smAndDown"
      @click="handleSearch(query)" fab fixed bottom right color="primary"
      style="margin-bottom: 80px; z-index: 1" elevation="0"
    >
      <v-icon>mdi-magnify</v-icon>
    </v-btn>
  </div>
</template>

<script>
import Navbar from "@/components/nav/Navbar.vue";
import axios from "axios";
import ItemCardOthers from "@/components/item/ItemCardOthers.vue";
import ItemCardLoading from "@/components/item/ItemCardLoading.vue";
import ProductPlans from "@/components/item/ProductPlans.vue";
import ProductDetailsOther from "@/components/item/ProductDetailsOther.vue";
import ItemCardMerchant from "@/components/item/ItemCardMerchant.vue";
import { shuffleArray } from "@/lib/utils.js";
import BottomNav from "@/components/BottomNav.vue";

export default {
  name: "SearchOthers",
  components: {
    BottomNav,
    ItemCardMerchant,
    ProductDetailsOther,
    ProductPlans,
    ItemCardLoading,
    ItemCardOthers,
    Navbar
  },
  metaInfo() {
    return {
      title: this.current ? this.current.name : `${ this.items.length } search result(s)`,
    }
  },
  data() {
    return {
      query: '',
      views: { search: false, details: false, plans: false, },
      pagination: { page: 1, end: false, },
      items: [],
      current: null,
      loading: false,
      params: {},
    }
  },
  created() {
    this.handleRouteChange();
  },
  methods: {
    async handleRouteChange() {
      const { q: search, jumia, jiji, konga, instagram } = this.$route.query;
      if (!jumia && !jiji && !konga && !instagram) {
        this.params = { jumia: true, instagram: true, jiji: true, konga: true };
      } else {
        this.params = {};
        if (`${ jumia }` === 'true') this.params.jumia = true;
        if (`${ jiji }` === 'true') this.params.jiji = true;
        if (`${ konga }` === 'true') this.params.konga = true;
        if (`${ instagram }` === 'true') this.params.instagram = true;
      }
      this.query = search;
      this.items = [];
      await this.fetchItems();
    },
    handleSearch(q) {
      this.views.search = false;
      const stores = [];
      if (this.params.jumia) stores.push('jumia');
      if (this.params.konga) stores.push('konga');
      if (this.params.instagram) stores.push('instagram');
      if (this.params.jiji) stores.push('jiji');
      this.$store.commit('global/set', { query: q, stores });
      this.$bus.$emit('modal', 'search');
    },
    async fetchItems(page = 1) {
      this.loading = true;
      const res = await axios.post(
        'https://lendnode.creditclan.com/stores/stores', { search: this.query }, { params: { ...this.params, page } }
      );
      try {
        const items = res.data.finalResult.map((r, i) => {
          if (r.source === 'jumia') {
            return {
              id: `temp-${ i }`,
              name: r.name,
              images: [r.image],
              price: +r.price,
              description: r.name,
              category_id: 12,
              source: r.source
            };
          }
          if (r.source === 'konga') {
            return {
              id: `temp-${ i }`,
              name: r.name,
              images: [`https://www-konga-com-res.cloudinary.com/w_auto,f_auto,fl_lossy,dpr_auto,q_auto/media/catalog/product${ r.image_thumbnail }`],
              price: +r.price,
              description: r.description,
              category_id: 12,
              source: r.source
            };
          }
          if (r.source === 'jiji') {
            return {
              id: `temp-${ i }`,
              name: r.title,
              images: r.images.map(i => i.url),
              price: +r.price_obj.value,
              description: r.short_description,
              category_id: 12,
              source: r.source
            };
          }
          if (r.source === 'instagram') {
            return r;
          }
          return null
        }).filter(i => !!i);
        this.items = shuffleArray(items);
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
    handleSelect(item) {
      this.views.details = true;
      this.current = item;
    },
    loadMore() {
      const { page, end } = this.pagination;
      if (!end) this.fetchItems(page + 1);
    },
  },
  watch: {
    '$route': 'handleRouteChange',
    views: {
      handler(v) {
        if (!v.plans && !v.details) this.current = null;
      },
      deep: true,
    }
  },
}
</script>
